import { createFileRoute } from '@tanstack/react-router';
import { candidateQuery, candidateSnapshotQuery, candidatesQuery } from '@/features/candidates/api';
import { CandidateReviewPage } from '@/features/candidates/pages/CandidateReviewPage';
import { candidatesSearchSchema } from '@/features/candidates/search';
import { sourcesQuery } from '@/features/sources/api';

// Carries the list's search, so the review knows its neighbours and the way back.
export const Route = createFileRoute('/_authed/ops/candidates/$candidateId')({
  staticData: { help: 'candidate-review' },
  validateSearch: candidatesSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, params, deps }) => {
    void queryClient.prefetchQuery(candidatesQuery(deps));
    void queryClient.prefetchQuery(sourcesQuery());
    const candidate = await queryClient.ensureQueryData(candidateQuery(params.candidateId));
    void queryClient.prefetchQuery(
      candidateSnapshotQuery(params.candidateId, candidate.pageSnapshotId),
    );
  },
  component: CandidateReviewPage,
});
